; (() => {
    document.querySelectorAll('.js-autoresize').forEach(el => {
        const defaultHeight = parseInt(el.dataset.defaultHeight, 10) || 30
        let offset = parseInt(el.dataset.offset, 10)
        let maxHeight = parseInt(el.dataset.maxHeight, 10) || 76

        if (offset !== 0 && !offset) offset = 20

        // el.setAttribute('style', `height: ${el.scrollHeight + offset}px; overflow-y: hidden;`)
        // el.setAttribute('style', `height: ${el.scrollHeight + offset}px; max-height: 76px; overflow-y:auto;`)
        el.setAttribute('style', `height: ${defaultHeight}px; max-height: ${maxHeight}px; overflow-y:hidden;`)

        el.addEventListener('input', updateInput)

        function updateInput() {
            if (el.value == '') {
                el.style.height = `${defaultHeight}px`
                el.style.overflow = 'hidden'
            } else {
                el.style.overflow = 'auto'
                el.style.height = 'auto'
                el.style.height = `${el.scrollHeight + offset}px`
            }
        }

        updateInput()
    })
})();